import { TypeDefinitionContext, useTypeDefinition } from './type-definition-context';
import { getSyntax } from './type-definition-entity';
import { TypeDefinitionIndent } from './type-definition-indent';
import { TypeDefinitionPair } from './type-definition-pair';
export const TypeDefinitionObject = () => {
  const {
    entity,
    indent = 0,
    language,
    ...ctx
  } = useTypeDefinition();
  const syntax = getSyntax(entity);

  // Node to prepend before the object property list
  let objectStart: React.ReactNode = <span className="token punctuation">{'{'}</span>;

  // Node to prepend after the object property list
  let objectEnd: React.ReactNode = <span className="token punctuation">{'}'}</span>;

  // Nodes to prepend before or after each object property
  let propertyStart: React.ReactNode = '';
  let propertyEnd: React.ReactNode = '';

  // Node to prepend after the last object property
  let lastPropertyEnd: React.ReactNode = '';
  if (language === 'js') {
    propertyEnd = <span className="token punctuation">;</span>;
    lastPropertyEnd = propertyEnd;
    if (entity.type?.includes('[]')) {
      objectEnd = <>
          {objectEnd}
          <span className="token operator">[]</span>
        </>;
    }
  }
  if (language === 'ruby') {
    if (syntax === 'class') {
      objectStart = '';
      objectEnd = <span className="token keyword">end</span>;
      propertyStart = <>
          <span className="token keyword">attr_accessor</span>{' '}
        </>;
    }
    if (syntax === 'object') {
      propertyEnd = <span className="token punctuation">,</span>;
    }
    if (entity.title?.startsWith('Hash')) {
      propertyStart = '';
    }
    if (entity.type?.startsWith('Array[')) {
      objectStart = <>
          <span className="token keyword">Array</span>
          <span className="token operator">[</span>
          <span className="token punctuation">{'{'}</span>
        </>;
      objectEnd = <>
          <span className="token punctuation">{'}'}</span>
          <span className="token operator">]</span>
        </>;
    }
  }
  if (language === 'python') {
    if (syntax === 'object') {
      propertyEnd = <span className="token punctuation">,</span>;
    }
    if (entity.type === 'list[dict]') {
      objectStart = <>
          <span className="token keyword">list</span>
          <span className="token operator">[</span>
          <span className="token punctuation">{'{'}</span>
        </>;
      objectEnd = <>
          <span className="token punctuation">{'}'}</span>
          <span className="token operator">]</span>
        </>;
    }
  }
  if (language === 'php') {
    propertyEnd = <span className="token punctuation">,</span>;
    if (syntax === 'array' || syntax === 'object') {
      objectStart = <span className="token operator">[</span>;
      objectEnd = <span className="token operator">]</span>;
    }
    if (syntax === 'class') {
      objectStart = <>
          {'\n'}
          <span className="token punctuation">{'{'}</span>
        </>;
      propertyStart = <span className="token keyword">public </span>;
      propertyEnd = <span className="token punctuation">;</span>;
      lastPropertyEnd = propertyEnd;
    }
  }
  if (language === 'dotnet') {
    propertyEnd = <span className="token punctuation">;</span>;
    lastPropertyEnd = propertyEnd;
  }
  return <>
      {objectStart}
      {entity.properties?.map((property, index, arr) => <span key={property.key}>
          {'\n'}
          <TypeDefinitionContext.Provider value={{
        entity: property,
        indent: indent + 1,
        language,
        ...ctx,
        syntax
      }}>
            <TypeDefinitionIndent />
            {propertyStart}
            <TypeDefinitionPair />
            {index + 1 < arr.length && propertyEnd}
            {index + 1 === arr.length && lastPropertyEnd}
          </TypeDefinitionContext.Provider>
        </span>)}
      {'\n'}
      <TypeDefinitionIndent data-sentry-element="TypeDefinitionIndent" data-sentry-source-file="type-definition-object.tsx" />
      {objectEnd}
    </>;
};